var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNewIcBell = function SvgNewIcBell(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.63825 12.2215L4.92326 11.7465V11.1925L4.92326 6.80788C4.92326 4.28011 6.97242 2.23096 9.50019 2.23096C12.028 2.23096 14.0771 4.28012 14.0771 6.80788L14.0771 11.1925L14.0771 11.7465L14.3621 12.2215L14.737 12.8463H4.26334L4.63825 12.2215ZM18.2694 14.8463L17.0694 12.8463L16.0771 11.1925L16.0771 6.80788C16.0771 3.17555 13.1325 0.230957 9.50019 0.230957C5.86785 0.230957 2.92326 3.17554 2.92326 6.80788L2.92326 11.1925L1.93096 12.8463L0.730957 14.8463H3.06334H5.91943C5.95697 15.0313 6.00848 15.2112 6.07281 15.3848C6.5886 16.7771 7.92851 17.7694 9.50019 17.7694C11.0719 17.7694 12.4118 16.7771 12.9276 15.3848C12.9919 15.2112 13.0434 15.0313 13.0809 14.8463H15.937H18.2694ZM9.50019 15.7694C9.90371 15.7694 10.2735 15.6249 10.5606 15.3848H8.43982C8.7269 15.6249 9.09667 15.7694 9.50019 15.7694Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNewIcBell, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/new_ic_bell.25ba17ed.svg";
export { ForwardRef as ReactComponent };